<template>
  <div class="row">
    <!-- Search -->
    <div class="col-3">
      <z-search
        v-model.trim="searchTerm"
        class="mt-2"
        name="search"
        label=""
        placeholder="search membership"
        :readonly="isLoading"
      />
    </div>
    <!-- Filter -->
    <div class="col-2 mt-2">
      <select v-model="filterBy" class="form-control">
        <option v-for="filter in filters" :key="filter.value" :value="filter.value">
          {{ filter.label }}
        </option>
      </select>
    </div>
    <!-- Pagination -->
    <div class="col-1 mt-2">
      <z-select
        v-model="pageSize"
        :options="pageSizes"
        label=""
        name="pageSize"
        :disabled="isLoading"
      />
    </div>
    <div class="col mt-2">
      <nav>
        <z-paginate v-model="page" :page-count="pages" />
      </nav>
    </div>
    <div class="col-2 mt-2 text-right">
      <h5 class="mt-0 me-0" title="# items">{{ numItems }}</h5>
      <span class="custom-items">items</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZPaginate from '@/components/utilities/elements/Paginate.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
export default {
  name: 'MemberHeader',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate
  },
  props: {
    pages: Number,
    pageSizes: Array,
    numItems: Number
  },
  data() {
    return {
      filters: [
        { label: 'All', value: 0 },
        { label: 'ADAS Map', value: 1 },
        { label: 'Mobile Copilot', value: 2 }
        // { label: 'Test Drive Copilot', value: 3 }
      ]
    }
  },
  emits: ['search'],
  computed: {
    ...mapState(locationStore, ['loading', 'listParams']),
    isLoading() {
      return this.loading.members
    },
    page: {
      get() {
        return this.listParams.page
      },
      set(value) {
        this.setListParam({
          name: 'page',
          value: parseInt(value)
        })
        this.search('')
      }
    },
    pageSize: {
      get() {
        return this.listParams.pageSize
      },
      set(value) {
        this.setListParam({
          name: 'pageSize',
          value: parseInt(value)
        })
        this.page = 1
      }
    },
    filterBy: {
      get() {
        return this.listParams.filterBy
      },
      set(value) {
        this.setListParam({
          name: 'filterBy',
          value: value
        })
        this.page = 1
      }
    },
    searchTerm: {
      get() {
        return this.listParams.searchTerm
      },
      set(value) {
        this.setListParam({
          name: 'searchTerm',
          value: value
        })
        this.page = 1
      }
    }
  },
  methods: {
    ...mapActions(locationStore, ['setListParam']),
    change() {
      this.search(this.listParams.searchTerm)
    },
    search() {
      this.$emit('search', this.page, this.listParams.searchTerm)
    }
  }
}
</script>
<style lang="scss" scoped>
.filterIcon {
  top: 8px;
  font-size: 1.2em;
  text-align: right;
}
.filterListing {
  float: left;
}
.custom-items {
  right: 10px;
  top: -10px;
  position: relative;
}
.custom-actions {
  display: inline-flex;
}
</style>
